module.exports = "./img/74a5024069e0d026979a367059abb8ec.jpg";